// src/features/rrhh/empleados/api/areasApi.js
import httpClient from "../../../../shared/api/httpClient";

function getLicenseIdOrThrow() {
  try {
    const v = localStorage.getItem("sabi_empresa_id");
    if (!v) throw new Error();
    const n = Number(v);
    if (!Number.isFinite(n) || n <= 0) throw new Error();
    return n;
  } catch {
    throw new Error("No se encontró sabi_empresa_id en localStorage (licencia/empresa requerida).");
  }
}

/**
 * LISTAR ÁREAS de la licencia activa
 * GET /admin/licenses/:licenseId/areas
 */
export const getAreas = () => {
  const licenseId = getLicenseIdOrThrow();
  return httpClient.get(`/admin/licenses/${licenseId}/areas`);
};